import React from "react";

import { Icon } from "@chakra-ui/react";
import { MdHome, MdAnalytics } from "react-icons/md";

import trifecta from "assets/trifecta.png";

import vertexAI from "assets/vertexAI.png";

// Admin Imports
import AnalyticsPage from "views/admin/AnalyticsPage";
import ChatBotPage from "views/admin/chatBotPage";

import SelectModulePage from "views/moduleFlow/SelectModulePage";
import StoragePage from "views/upload";

import { FcUpload, FcTimeline } from "react-icons/fc";

const routes = [
  {
    name: "Upload Files",
    layout: "/admin",
    path: "/storage-page",
    icon: <Icon as={FcUpload} width="20px" height="20px" color="inherit" />,
    component: StoragePage,
    module: null,
  },
  // {
  //   name: "Document Classification",
  //   layout: "/admin",
  //   path: "/document-classification",
  //   icon: <Icon as={FcTimeline} width="20px" height="20px" color="inherit" />,
  //   component: ChatBotPage,
  //   module: null,
  // },
  // {
  //   name: "Dataprep",
  //   layout: "/admin",
  //   path: "/trifecta",
  //   icon: (
  //     <img
  //       alt="trifecta"
  //       src={trifecta}
  //       width="25px"
  //       height="25px"
  //       color="inherit"
  //     />
  //   ),
  //   component: AnalyticsPage,
  //   module: null,
  // },
  // {
  //   name: "Chat AI",
  //   layout: "/admin",
  //   path: "/chat-page",
  //   icon: (
  //     <img
  //       alt="llm"
  //       src={vertexAI}
  //       width="25px"
  //       height="25px"
  //       color="inherit"
  //     />
  //   ),
  //   component: ChatBotPage,
  //   module: null,
  // },
  // {
  //   name: "Analytics",
  //   layout: "/admin",
  //   path: "/analytics",
  //   icon: <Icon as={MdAnalytics} width="20px" height="20px" color="inherit" />,
  //   component: AnalyticsPage,
  //   module: null,
  // },
];

export default routes;
